export default Object.freeze({
  Emergency: 'EMERGENCY',
  HomeDom: 'HOME-DOM',
  HomeInt: 'HOME-INT',
  Postal: 'POSTAL',
  OsPostal: 'OS-POSTAL',
  SemDom: 'SEM-DOM',
  SemInt: 'SEM-INT',
  Permanent: 'P',
  Contact: 'C',
  Semester: 'S'
})
